const initialState = {};

export const AppReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
